// extracted by mini-css-extract-plugin
export default {"loading-overlay":"App_loading-overlay__vXl6T","overlay":"App_overlay__fNUSq"};